import axios from 'axios';

const personEndpoint = '/api/person';
const requestEndpoint = '/api/request';

class PersonAPI {
    // GET
    async getPersonalData(token){  // Get user personal data
        return axios({
            method: 'get',
            url: personEndpoint,
            headers: {
                'Authorization': 'Bearer ' + token
            },
        });
    }
    async getStatusOfUpdate(token, id){     // Get status of "update_data" request (by id)
        return axios({
            method: 'get',
            url: requestEndpoint + '/' + id,
            headers: {
                'Authorization': 'Bearer ' + token
            },
        })
    }

    // PUT
    async updateData(token, personData){   // Update user personal data request
        return axios({
            method: 'put',
            url: personEndpoint,
            data: personData,
            headers: {
                'Authorization': 'Bearer ' + token
            },
        });
    }
    async requestEmailUpdate(token, newEmail){   // Update email request
        return axios({
            method: 'put',
            url: personEndpoint + '/email',
            data: {
                "email": newEmail
            },
            headers: {
                'Authorization': 'Bearer ' + token
            },
        });
    }
    async verifyCode(token, newEmail, pin){   // Verify PIN (received on new email address)
        return axios({
            method: 'put',
            url: personEndpoint + '/email/verify-pin',
            data: {
                "email": newEmail,
                "pin": pin
            },
            headers: {
                'Authorization': 'Bearer ' + token
            },
        });
    }

    
}

export default new PersonAPI();
